import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import { useStore } from '@link/agent/stores';
import { Loader } from '@link/share/components';

const AgentLayout: React.FC = () => {
  const { agent } = useStore();

  useEffect(() => {
    if (agent.selectedAgentId) {
      agent.getCurrentOta(agent.selectedAgentId);
    }
  }, [agent.selectedAgentId, agent]);

  return agent.detailLoaded ? <Outlet /> : <Loader />;
};

const AgentLayoutView = observer(AgentLayout);

export default AgentLayoutView;
